import { SpaceContributionsTable } from '@/components/space-contributions'

/**
 * Space Contributions Management Page
 * Displays list of space contributions with CRUD operations
 */
export function SpaceContributionsPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto py-8 px-4">
        <div className="mb-8">
          <h1 className="text-3xl font-bold tracking-tight">Space Contributions</h1>
          <p className="text-muted-foreground mt-2">
            Manage available hangar space when aircraft are away or lease spots are empty
          </p>
        </div>

        <SpaceContributionsTable />
      </div>
    </div>
  )
}
